<div *ngIf="role"
      class="row">
    <div class="col-md-12">
        <form class="form-validation">
            <div *ngIf="!role.id"
                  class="row mb-3 button-sticky">
                <div class="col-12 mb-3">
                    <primary-text-button [noLeftPadding]="true"
                                         (onClick)="addNewRole()"
                                         [disabled]="isLoading || !role.name || desc.invalid || !role.shortName || sname.errors?.length > 0">
                        {{ 'general.create' | translate }}
                    </primary-text-button>
                </div>
            </div>
            <!-- Only on new -->
            <div class="row">
                <!-- Edit & new from here -->
                <div class="col-12">
                    <div class="row mb-4 det-row pr-3 pr-md-0">
                      <div class="d-flex justify-content-between list-itemPart first col-12 {{role.id ? 'col-md-6' : ''}} flex-auto pr-0" >
                        <div class="input-group">
                          <div style="flex: 0 0 70%">
                            <div class="list-title d-flex w-100 pr-3">
                                <span class="field-required">
                                  {{ 'roles.name' | translate }}
                                </span>
                            </div>
                            <form class="form-controller">
                                <input class="form-control"
                                       type="text"
                                       name="roleName"
                                       [(ngModel)]="role.name"
                                       placeholder="{{ 'Type a role name' | translate }}"
                                       (focus)="startEdit($event)"
                                       (focusout)="submitEditOnFocus($event);$event.stopPropagation()"
                                       style="border-top-right-radius:0;border-bottom-right-radius:0;"
                                       required />
                            </form>
                          </div>
                          <div style="flex: 0 0 30%">
                              <div class="list-title mr-3 mr-md-0">
                                  <span class="field-required">
                                    {{ 'roles.short_name' | translate }}
                                  </span>
                              </div>
                              <form class="form-controller">
                                  <input required
                                         class="form-control"
                                         type="text"
                                         name="roleShortName"
                                         [(ngModel)]="role.shortName"
                                         [rangeLength]="[2, 20]"
                                         #sname="ngModel"
                                         (focus)="startEdit($event)"
                                         (focusout)="submitEditOnFocus($event);$event.stopPropagation()"
                                         style="border-left:0;border-radius:0" />
                              </form>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="row mb-4">
                        <div class="col-md-12 pr-md-0 mb-3">
                            <label class="list-title">{{ 'roles.section_description' | translate }}</label>
                            <textarea name="description"
                                      [(ngModel)]="role.description"
                                      class="form-control oneline-textarea"
                                      (focus)="startEdit($event)"
                                      (focusout)="submitEditOnFocus($event);$event.stopPropagation()"
                                      rows=1
                                      #desc="ngModel"
                                      [rangeLength]="[0, 256]"></textarea>
                            <p class="validation-error"
                               *ngIf="desc.errors?.rangeLength">{{ 'form.validate.maxLenght' | translate }} 256!</p>
                        </div>
                    </div>
                    
                    <div class="row mb-4">

                      <div class="col-6 col-lg-4 pr-md-0 mb-3">
                        <label class="list-title">{{ 'bots.typeSelector' | translate }}</label>
                        <select name="botType" class="form-control" [(ngModel)]="role.botType"
                          (change)="submitEditOnFocus($event);$event.stopPropagation()">
                          <option disabled selected>{{ 'general.select' | translate }}</option>
                          <option value="data">{{ 'bots.dataBot' | translate }}</option>
                          <option value="document">{{ 'bots.documentBot' | translate }}</option>
                          <option value="message">{{ 'bots.messageBot' | translate }}</option>
                        </select>
                      </div>

                      <div class="col-6 col-lg-4 pr-md-0 mb-3" *ngIf="role.botType === 'data'">
                        <label class="list-title">{{ 'bots.categorySelector' | translate }}</label>
                        <select name="category" class="form-control" [(ngModel)]="role.category"
                          (change)="role.botServiceId = '';submitEditOnFocus($event);$event.stopPropagation()">
                          <option disabled selected>{{ 'general.select' | translate }}</option>
                          <option value="create">{{ 'bots.categoryCreate' | translate }}</option>
                          <option value="exist">{{ 'bots.categoryExist' | translate }}</option>
                          <option value="list">{{ 'bots.categoryList' | translate }}</option>
                          <option value="read">{{ 'bots.categoryRead' | translate }}</option>
                          <option value="log">{{ 'bots.categoryLog' | translate }}</option>
                          <option value="update">{{ 'bots.categoryUpdate' | translate }}</option>
                          <option value="listener">{{ 'bots.categoryListener' | translate }}</option>
                          <option value="other">{{ 'bots.categoryOther' | translate }}</option>
                        </select>
                      </div>

                      <div class="col-6 col-lg-4 pr-md-0 mb-3" *ngIf="role.botType === 'document'">
                        <label class="list-title">{{ 'bots.categorySelector' | translate }}</label>
                        <select name="category" class="form-control" [(ngModel)]="role.category"
                          (change)="submitEditOnFocus($event);$event.stopPropagation()">
                          <option disabled selected>{{ 'general.select' | translate }}</option>
                          <option value="document_generate_and_display">{{ 'bots.document_generate_and_display' | translate }}</option>
                          <option value="document_generate_and_upload">{{ 'bots.document_generate_and_upload' | translate }}</option>
                          <option value="document_generate_upload_display">{{ 'bots.document_generate_upload_display' | translate }}</option>
                          <option value="document_upload">{{ 'bots.document_upload' | translate }}</option>
                        </select>
                      </div>
                    </div>

                    <div class="row mb-4" *ngIf="role.botType === 'document'">
                      <div class="col-md-6 pr-md-0 mb-3">
                        <label class="list-title">{{ 'bots.certificateSelector' | translate }}</label>
                        <select name="selectedPrint" class="form-control" [(ngModel)]="role.selectedPrint"
                          (change)="submitEditOnFocus($event);$event.stopPropagation()">
                          <option disabled selected>{{ 'general.select' | translate }}</option>
                          <option *ngFor="let item of printDocuments" value="{{item.id}}">{{ item.name }}</option>
                        </select>
                      </div>
                    </div>

                    <div class="row mb-4">
                      <div class="col-md-12 pr-md-0 mb-3">
                          <label class="list-title">{{ 'bots.success_message' | translate }}</label>
                          <textarea name="success_message"
                                    [(ngModel)]="role.botSuccessMessage"
                                    class="form-control oneline-textarea"
                                    (focus)="startEdit($event)"
                                    (focusout)="submitEditOnFocus($event);$event.stopPropagation()"
                                    rows=1
                                    [rangeLength]="[0, 256]"></textarea>
                          <p class="validation-error"
                             *ngIf="desc.errors?.rangeLength">{{ 'form.validate.maxLenght' | translate }} 256!</p>
                      </div>
                  </div>

                  <div class="row mb-4">
                    <div class="col-md-12 pr-md-0 mb-3">
                        <label class="list-title">{{ 'bots.fail_message' | translate }}</label>
                        <textarea name="fai_message"
                                  [(ngModel)]="role.botSFailMessage"
                                  class="form-control oneline-textarea"
                                  (focus)="startEdit($event)"
                                  (focusout)="submitEditOnFocus($event);$event.stopPropagation()"
                                  rows=1
                                  [rangeLength]="[0, 256]"></textarea>
                        <p class="validation-error"
                           *ngIf="desc.errors?.rangeLength">{{ 'form.validate.maxLenght' | translate }} 256!</p>
                    </div>
                </div>
                    
                </div>
            </div>
        </form>
    </div>
</div>
